module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_features_03-056a1b03b59a83528c90b62f76d1e726.png";